// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpRepomgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpRepomgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpRepomgrIconOutlined = function DrrpRepomgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpRepomgrIconOutlinedSvg
  }));
};

DrrpRepomgrIconOutlined.displayName = 'DrrpRepomgrIconOutlined';
export default React.forwardRef(DrrpRepomgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpRepomgrIconOutlined.js
// module id = 2569
// module chunks = 0